"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationUnit = void 0;
/**
 * This represents the unit of duration for a financial product provided by VWFS. Currently
 * all products are monthly paid and therefore there is only one value. This may change in the
 * future
 */
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["MONTHS"] = "MONTHS";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
